import React, { useEffect, useState } from 'react';
import SearchHeader from '../../Common/SearchHeader';
import JoinTribe from '../../Common/JoinTribe';
import FindYourTribe from '../../Common/FindYourTribe';
import { ReactComponent as CheckMark } from '../../../Assets/checkmark.svg';
import { ReactComponent as DownArrow } from '../../../Assets/down-arrow.svg';
import { ReactComponent as UpArrow } from '../../../Assets/up-arrow.svg';
import { ReactComponent as YourBooking } from '../../../Assets/booking-heading.svg';
import './style.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { QRCode, Table } from 'antd';
import Loading from 'react-fullscreen-loading';
import TicketIcon from '../../../Assets/ticket-icon.svg';
import { downloadBookingTicket } from '../../../Redux/slices/cartSlice';
import { dateFormatter } from '../../../utils/helpers';
import { orderColumns } from '../../../utils/Constant';

const TicketDetail = () => {
  const { orderDetails, downloadTicketLoading } = useSelector(
    (state) => state.cart
  );

  const [viewOrderSummary, setViewOrderSummary] = useState(false);
  const dispatch = useDispatch();
  const [ticketData, setTicketData] = useState([]);

  const toggleOrderSummary = () => {
    setViewOrderSummary(!viewOrderSummary);
  };
  const navigate = useNavigate();

  useEffect(() => {
    if (!orderDetails) {
      navigate('/');
    }
    const tableData = [];
    orderDetails.tickets.forEach((ticket) => {
      const ticketData = orderDetails.event.tickets.find(
        (val) => val.id === ticket.ticket
      );
      tableData.push({
        item: (
          <div>
            <div>{ticketData.title}</div>
            <div className="summary-time">
              {dateFormatter(
                orderDetails.event.startDate,
                orderDetails.event.endDate
              )}
            </div>
          </div>
        ),
        qty: ticket.qty ?? 0,
        totalInString: `₹${ticketData.price * ticket.qty}`,
      });
    });
    tableData.push({
      item: 'Booking Fee',
      qty: '',
      totalInString: `₹${orderDetails.payment.bookingAmount}`,
    });
    if (orderDetails.payment.discountAmount > 0) {
      tableData.push({
        item: 'Coupon Discount',
        qty: '',
        totalInString: `₹${orderDetails.payment.discountAmount}`,
      });
    }
    setTicketData(tableData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, orderDetails);

  return (
    <div>
      <SearchHeader styleClass="header" showSearchBar={true} />
      <div className="thankyou thankyou-mobile border-radius-14">
        <div>
          <h3 className="thank-you-text">Thank you for your purchase!</h3>
          <p>
            We will send you an e-mail/SMS confirmation within 15 minutes. You
            should be able to access the event using the ticket below. Please
            check your confirmation mailer for COVID entry protocols.
          </p>
        </div>
        <CheckMark />
      </div>
      <div className="ticketDetail">
        <div className="thankyou thankyou-desktop border-radius-14">
          <div>
            <h3 className="thank-you-text">Thank you for your purchase!</h3>
            <p>
              We will send you an e-mail/SMS confirmation within 15 minutes. You
              should be able to access the event using the ticket below. Please
              check your confirmation mailer for COVID entry protocols.
            </p>
          </div>
          <CheckMark />
        </div>
        <div className="your-booking">
          <div className="heading">
            <YourBooking />
            <h2>YOUR BOOKING</h2>
          </div>
          <div
            style={{
              padding: '40px 24px',
              // border: "solid 1px #ccc",
              display: 'flex',
              gap: 32,
              backgroundImage:
                'url(https://studenttribe-dev.s3.ap-south-1.amazonaws.com/images/ticket-background.png)',
              backgroundRepeat: 'no-repeat',
              width: '100%',
              backgroundSize: '100% 100%',
            }}
            className="border-radius-14 ticket-container"
          >
            <div className="sub-ticket-container">
              <img
                src={orderDetails?.event?.coverImg}
                style={{ height: 220 }}
                alt="Cover Img"
                className="ticket-image"
              />
              <div
                style={{
                  flex: 1,
                }}
                className="ticket-data-container-mobile"
              >
                <div
                  style={{
                    fontSize: 24,
                    fontWeight: 600,
                    color: '#000',
                  }}
                  className="ticket-confirm-title"
                >
                  {orderDetails.event.title}
                </div>
                <div
                  style={{ marginTop: 20, fontSize: 16, color: '#525252' }}
                  className="ticket-confirm-details"
                >
                  {orderDetails.event.location.addressLine1}
                  <br />
                  {orderDetails.event.location.addressLine2}
                  <br />
                  {orderDetails.event.location.city}
                  <br />
                  {orderDetails.event.location.state}
                  <br />
                  {moment(orderDetails.event.startDate).format(
                    'MMMM Do YYYY, hh:mma'
                  )}
                </div>
                <div
                  style={{ marginTop: 20 }}
                  className="particular-ticket-container"
                >
                  {orderDetails.tickets.map((ticket) => {
                    const ticketData = orderDetails.event.tickets.find(
                      (val) => val.id === ticket.ticket
                    );
                    return (
                      <div
                        key={`Ticket-${ticket.ticket}`}
                        style={{
                          display: 'flex',
                          gap: 10,
                          alignItems: 'center',
                        }}
                        className="particular-ticket-data"
                      >
                        <img
                          src={TicketIcon}
                          width={20}
                          height={20}
                          alt="ticket-icon"
                        />
                        <div
                          style={{
                            fontSize: 20,
                            fontWeight: 600,
                            color: '#CE202F',
                          }}
                          className="ticket-text"
                        >
                          {ticketData.title} - {ticket.qty} ticket(s)
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
              }}
              className="qr-code-main-container"
            >
              <div
                style={{
                  flex: 1,
                }}
                className="ticket-data-container-desktop"
              >
                <div
                  style={{
                    fontSize: 24,
                    fontWeight: 600,
                    color: '#000',
                  }}
                >
                  {orderDetails.event.title}
                </div>
                <div style={{ marginTop: 20, fontSize: 16, color: '#525252' }}>
                  {orderDetails.event.location.addressLine1}
                  <br />
                  {orderDetails.event.location.addressLine2}
                  <br />
                  {orderDetails.event.location.city}
                  <br />
                  {orderDetails.event.location.state}
                  <br />
                  {moment(orderDetails.event.startDate).format(
                    'MMMM Do YYYY, hh:mma'
                  )}
                </div>
                <div style={{ marginTop: 20 }} className="">
                  {orderDetails.tickets.map((ticket) => {
                    const ticketData = orderDetails.event.tickets.find(
                      (val) => val.id === ticket.ticket
                    );
                    return (
                      <div
                        key={`Ticket-${ticket.ticket}`}
                        style={{
                          display: 'flex',
                          gap: 10,
                          alignItems: 'center',
                        }}
                      >
                        <img
                          src={TicketIcon}
                          width={20}
                          height={20}
                          alt="ticket-icon"
                        />
                        <div
                          style={{
                            fontSize: 20,
                            fontWeight: 600,
                            color: '#CE202F',
                          }}
                        >
                          {ticketData.title} - {ticket.qty} ticket(s)
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '21rem',
                }}
              >
                <QRCode
                  value={orderDetails._id}
                  size={220}
                  style={{ marginLeft: '4%' }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="btn-container">
          <div
            className="button view border-radius-8 view view-ticket-cta"
            onClick={toggleOrderSummary}
            onKeyDown={toggleOrderSummary}
          >
            View Order Details {viewOrderSummary ? <UpArrow /> : <DownArrow />}
          </div>
          <div
            className="button border-radius-8 view-ticket-cta"
            onClick={() =>
              dispatch(
                downloadBookingTicket({
                  id: orderDetails.payment.orderId
                    ? orderDetails.payment.orderId
                    : orderDetails._id,
                })
              )
            }
            onKeyDown={() =>
              dispatch(
                downloadBookingTicket({ id: orderDetails.payment.orderId })
              )
            }
          >
            Download Ticket
          </div>
        </div>
        {viewOrderSummary && (
          <div
            className={`ticket-summary-container ${
              viewOrderSummary && 'showSummary'
            } square-container border-radius-14`}
            style={{
              width: '100%',
            }}
          >
            <div
              className="square-heading ticket-summary-heading"
              style={{
                marginBottom: 16,
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              Order Summary
              <div
                style={{
                  display: 'flex',
                  gap: 28,
                  color: '#666666',
                  fontSize: 16,
                }}
                className="order-details-desktop"
              >
                <div>Order Id: {orderDetails._id}</div>
                <div>
                  Booking Date and Time:{' '}
                  {moment(orderDetails.createdAt).format('MMM DD YYYY, hh:mmA')}
                </div>
              </div>
            </div>
            <Table
              className="order-summary-table"
              dataSource={ticketData}
              columns={orderColumns}
              pagination={{
                position: ['none', 'none'],
              }}
            />
            <div className="total-amount-container">
              <div className="total-payable-amount-text">
                Total Payable Amount
              </div>
              <div className="total-payable-amount">
                ₹
                {orderDetails.payment.ticketAmount +
                  orderDetails.payment.bookingAmount -
                  orderDetails.payment.discountAmount}
              </div>
            </div>
          </div>
        )}
        {viewOrderSummary && (
          <div
            className={`order-summary-container order-summary-container-mobile ${
              viewOrderSummary && 'showSummary'
            } square-container border-radius-14`}
            style={{
              width: '100%',
            }}
          >
            <div className="square-heading">
              Booking Details
              <div className="order-details-mobile">
                <div className="booking-detail-mobile-line">
                  <span> Order Id:</span>
                  <span> {orderDetails._id}</span>
                </div>

                <div className="booking-detail-mobile-line">
                  <span> Booking Date and Time:</span>
                  <span>
                    {' '}
                    {moment(orderDetails.createdAt).format(
                      'MMM DD YYYY, hh:mmA'
                    )}
                  </span>{' '}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <JoinTribe />
      <FindYourTribe />
      <Loading
        loading={downloadTicketLoading}
        background="#000000AA"
        loaderColor="#3498db"
      />
    </div>
  );
};

export default TicketDetail;
